import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'
import { darken } from '@material-ui/core/styles/colorManipulator'

const NewButton = withStyles(theme => ({
  root: {
    color: props => props.textcolor,
    backgroundColor: props => props.backgroundcolor,
    padding: props => (props.hasIcon ? 0 : '10px 30px'),
    minWidth: props => props.hasIcon && 32,
    height: props => props.hasIcon && 30,
    display: props => (!props.showButton ? 'none' : 'inherit'),
    fontSize: '12px',
    [theme.breakpoints.up('sm')]: {
      fontSize: '14px',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '16px',
    },
    letterSpacing: 'normal',
    '&:hover': {
      backgroundColor: props => darken(props.backgroundcolor, 0.1),
    },
    '& .MuiSvgIcon-root': {
      margin: props => (props.hasIcon ? 0 : '0 0 0 14px'),
      fontSize: props => (props.hasIcon ? 30 : 20),
    },
  },
}))(Button)

const CustomButton = ({ background, children, className, color, href, hasIcon, onClick, showButton, ...rest }) => (
  <NewButton
    backgroundcolor={background}
    className={className}
    href={href}
    onClick={onClick}
    textcolor={color}
    hasIcon={hasIcon}
    showButton={showButton}
    {...rest}
  >
    {children}
  </NewButton>
)

CustomButton.defaultProps = {
  background: 'rgba(255,255,255,0)',
  color: '#4A4A4A',
  hasIcon: false,
  showButton: true,
}

export default CustomButton
